import UnionTplEntry from './index';

const routes = [
  {
    path: '/',
    name: 'home',
    component: UnionTplEntry
  }
];

export async function router() {
  return routes;
}
